import { z } from 'zod';

import {
  PrintStatusSchema,
  PurchasePrintAttemptOutcomeSchema,
  PurchaseReceiptCopyRoleSchema,
  PurchaseReceiptModeSchema,
} from './purchases.schema.js';
import type {
  AttemptPurchasePrintRequest,
  AttemptPurchasePrintResponse,
  UpdatePurchasePrintStatusRequest,
  UpdatePurchasePrintStatusResponse,
} from './purchases-print.dto.js';
import { purchasePrintStatusUpdateValues } from './purchases.dto.js';

export const UpdatePurchasePrintStatusRequestSchema: z.ZodType<UpdatePurchasePrintStatusRequest> =
  z.object({
    companyId: z.uuid(),
    storeId: z.uuid(),
    locationId: z.uuid(),
    stationId: z.uuid(),
    purchaseId: z.uuid(),
    copyRole: PurchaseReceiptCopyRoleSchema.optional(),
    status: z.enum(purchasePrintStatusUpdateValues),
    printedAt: z.iso.datetime().nullable().optional(),
    skipPendingResolvePermission: z.boolean().optional(),
  });

export const UpdatePurchasePrintStatusResponseSchema: z.ZodType<UpdatePurchasePrintStatusResponse> =
  z.object({
    printStatus: PrintStatusSchema,
  });

export const AttemptPurchasePrintRequestSchema: z.ZodType<AttemptPurchasePrintRequest> =
  z.object({
    companyId: z.uuid(),
    storeId: z.uuid(),
    locationId: z.uuid(),
    stationId: z.uuid(),
    purchaseId: z.uuid(),
    copyRole: PurchaseReceiptCopyRoleSchema.optional(),
    receiptMode: PurchaseReceiptModeSchema.optional(),
  });

export const AttemptPurchasePrintResponseSchema: z.ZodType<AttemptPurchasePrintResponse> =
  z.object({
    printStatus: PrintStatusSchema,
    printAttemptOutcome: PurchasePrintAttemptOutcomeSchema,
    printAttemptMessage: z.string().trim().min(1).nullable().optional(),
  });
